import React from "react";
import { Box, Flex, Text, Divider, Button, useToast } from "@chakra-ui/react";

const Row = ({ label, value }) => (
  <Flex width="100%" justifyContent="space-between" my="8px">
    <Text fontSize="13px" color="#666">
      {label}
    </Text>
    <Text fontSize="14px" fontWeight="semibold">
      {value}
    </Text>
  </Flex>
);

// Manual bank-transfer launch mode — replaces the Paystack checkout panel
// for estates whose paymentSettings.paymentMode is BANK_TRANSFER. Purely
// informational: there is no submit/buy action here. This page never marks
// anything as paid and never triggers a vend — the resident transfers the
// funds themselves, outside the app, then the Estate Admin confirms receipt
// and approves the top-up (and vend) from the admin Top Up page.
export const BankTransferDetails = ({ bankTransfer, amount }) => {
  const toast = useToast();
  const { bankName, accountName, accountNumber, instructions } = bankTransfer || {};
  const hasDetails = bankName && accountName && accountNumber;

  return (
    <Box bg="#fff" border="1px solid #f2f2f2" borderRadius="12px" p="20px">
      <Text color="#10112B" fontWeight="semibold" mb="10px">
        Pay for water by bank transfer
      </Text>
      <Text fontSize="13px" color="gray.600" mb="15px">
        Your utility will be credited after your estate administrator confirms the transfer.
      </Text>

      {hasDetails ? (
        <>
          <Divider />
          <Row label="Amount to transfer" value={`₦${Number(amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`} />
          <Row label="Bank Name" value={bankName || "—"} />
          <Row label="Account Name" value={accountName || "—"} />
          <Row label="Account Number" value={accountNumber || "—"} />
          <Button mt="10px" onClick={async () => {
            try {
              await navigator.clipboard.writeText(accountNumber);
              toast({ title: "Account number copied", status: "success" });
            } catch (_) {
              toast({ title: "Could not copy. Please copy the account number manually.", status: "error" });
            }
          }}>Copy Account Number</Button>
          <Divider />
          {instructions && (
            <Text fontSize="13px" color="gray.600" mt="15px">
              {instructions}
            </Text>
          )}
        </>
      ) : (
        <Text fontSize="13px" color="red.500">
          Bank transfer details have not been configured for this estate yet.
          Please contact your estate administrator.
        </Text>
      )}
    </Box>
  );
};
